import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";
import absoluteURL from "@/lib/absoluteURL";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags(channel, link, course) {
  var _link$values, _channel$genres;
  const viewType = link === null || link === void 0 || (_link$values = link.values) === null || _link$values === void 0 ? void 0 : _link$values.view_type;
  const url = link === null || link === void 0 ? void 0 : link.url;
  const genre = (channel === null || channel === void 0 || (_channel$genres = channel.genres) === null || _channel$genres === void 0 || (_channel$genres = _channel$genres[0]) === null || _channel$genres === void 0 ? void 0 : _channel$genres.name) || "";
  const trialText = course !== null && course !== void 0 && course.trial_flag ? ` | ${course === null || course === void 0 ? void 0 : course.trialTerm}トライアル実施中` : "";
  switch (viewType) {
    case "live_schedule":
      return {
        title: `${channel.name}【${genre}】 - ${link.title} の動画配信 | SPOOX`,
        keywords: `${channel.name},SPOOX,スプークス,動画配信,番組表,スカパー！`,
        description: `${link.title}。SPOOX(スプークス)では、${channel.name}の動画を配信中です。`,
        og: {
          type: "article",
          url: `${config.host.vod}${routes.channelDetail(channel.id, url)}`,
          title: `SPOOX(スプークス) ${channel === null || channel === void 0 ? void 0 : channel.name} 月額${course === null || course === void 0 ? void 0 : course.price}円${trialText}`,
          image: absoluteURL({
            url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl
          })
        },
        twitter: {
          title: `SPOOX(スプークス) ${channel === null || channel === void 0 ? void 0 : channel.name} 月額${course === null || course === void 0 ? void 0 : course.price}円${trialText}`,
          card: "summary",
          image: absoluteURL({
            url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl
          })
        }
      };
    case "palette":
      return {
        title: `${channel.name}【${genre}】 - ${link.title} の動画配信 | SPOOX`,
        keywords: `${channel.name},SPOOX,スプークス,動画配信,スカパー！`,
        description: `${link.title}。SPOOX(スプークス)では、${channel.name}の動画を配信中です。`,
        og: {
          type: "article",
          url: `${config.host.vod}${routes.channelDetail(channel.id, url)}`,
          title: `SPOOX(スプークス) ${channel === null || channel === void 0 ? void 0 : channel.name} 月額${course === null || course === void 0 ? void 0 : course.price}円${trialText}`,
          image: absoluteURL({
            url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl
          })
        },
        twitter: {
          title: `SPOOX(スプークス) ${channel === null || channel === void 0 ? void 0 : channel.name} 月額${course === null || course === void 0 ? void 0 : course.price}円${trialText}`,
          card: "summary",
          image: absoluteURL({
            url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl
          })
        }
      };
    case "canvas":
    default:
      return {
        title: `${channel.name}【${genre}】の動画配信 | SPOOX(スプークス)`,
        keywords: `${channel.name},SPOOX,スプークス,動画配信,スカパー！`,
        description: `SPOOX(スプークス)では、${channel.name}の動画を配信中です。`,
        og: {
          type: "article",
          url: `${config.host.vod}${routes.channelDetail(channel.id)}`,
          title: `SPOOX(スプークス) ${channel === null || channel === void 0 ? void 0 : channel.name} 月額${course === null || course === void 0 ? void 0 : course.price}円${trialText}`,
          image: absoluteURL({
            url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl
          })
        },
        twitter: {
          title: `SPOOX(スプークス) ${channel === null || channel === void 0 ? void 0 : channel.name} 月額${course === null || course === void 0 ? void 0 : course.price}円${trialText}`,
          card: "summary",
          image: absoluteURL({
            url: channel === null || channel === void 0 ? void 0 : channel.thumbnailUrl
          })
        }
      };
  }
}
export default function ChannelDetailMetaTags(_ref) {
  let {
    channel,
    link,
    course
  } = _ref;
  const props = tags(channel, link, course);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}